import {IInsurerItem} from '../../../models/insurer.model';
import {
  InsurerActions,
  InsurerActionsType,
} from '../../action/insurer/insurer.actions';

export const insurerFeatureKey = 'insurers';

export interface InsurerState {
  insurers: IInsurerItem[];
}

export const initialInsurerState: InsurerState = {
  insurers: [],
};

export const insurerLoadReducer = (
  state = initialInsurerState,
  action: InsurerActions = {} as InsurerActions,
): InsurerState => {
  if (action.type === InsurerActionsType.load) {
    return {
      ...state,
      insurers: action.payload.insurers,
    };
  }
  return state;
};
